import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import FallbackComponent from "./FallbackComponent"

const ManageExpertOrders = lazy(() => import("../pages/expert/ManageExpertOrders"));
const ExpertTaskSearch = lazy(() => import("../pages/expert/search/task"));
const ExpertProfileSettings = lazy(() => import("../pages/expert/profile-settings"));
const ExpertAccountSettings = lazy(() => import("../pages/expert/account-settings"));
const ExpertPaymentTransactions = lazy(() => import("../pages/expert/payment-transactions"));
const ExpertDisputeResolution = lazy(() => import("../pages/expert/dispute-resolution"));

const ExpertPath = () => {
    return (
        <Routes>
            <Route path="*" element={<Navigate replace to={`/expert/orders`} />} />
            <Route path="orders" element={<Suspense fallback={<FallbackComponent />}><ManageExpertOrders /></Suspense>} />
            <Route path="transactions" element={<Suspense fallback={<FallbackComponent />}><ExpertPaymentTransactions /></Suspense>} />
            <Route path="profile-settings" element={<Suspense fallback={<FallbackComponent />}><ExpertProfileSettings /></Suspense>} />
            <Route path="account-settings" element={<Suspense fallback={<FallbackComponent />}><ExpertAccountSettings /></Suspense>} />
            <Route path="search" element={<Suspense fallback={<FallbackComponent />}><ExpertTaskSearch /></Suspense>} />
            <Route path="dispute-resolution" element={<Suspense fallback={<FallbackComponent />}><ExpertDisputeResolution /></Suspense>} />
        </Routes>
    );
}

export default ExpertPath;
